//  CardTemplate.js
//
//  Updated 2/6.
//
//  Abstract: Card template for Login, Register, About, and Support.

//	React
import React, { useEffect, useState } from 'react';
import BottomBar from '../BottomBar/BottomBar.js';
//	Assets
import allergiLogo from '../../../assets/logos/allergi-logo.png';
import mayoLogo from '../../../assets/logos/mayo-logo.png';
import clsx from 'clsx';

//	Material-ui styles
import { 
	makeStyles, 
	Card, 
	Container, 
	CssBaseline, 
	Link, 
	Typography 
} from '@material-ui/core';

//	Define CSS styles
const useStyles = makeStyles((theme) => ({
	card: {
		marginTop: theme.spacing(10),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '10%',
	},
	progess: {
		position: 'absolute'
	},
	logos: {
		width: '75px',
		justifyContent: 'center'
	},
	mayoLogo: {
		marginTop: '25px'
	},
	blue: {
		backgroundColor: 'blue'
	},
	title: {
		color: 'black',
		marginTop: '20%',
		marginBottom: '20%',
		
		textAlign: 'center'
	}
}));


export default function CardTemplate(props) {

	//	CSS classes
	const classes = useStyles();
	//	Card width prop
	const { cardMaxWidth = "xs", backgroundColor='white' } = props;
	// const blueBackground = backgroundColor === 'blue';

	return (
		<>
			<Container component="main" maxWidth={cardMaxWidth} >

				<CssBaseline />
				<Card elevation={0} variant="outlined" className={classes.card}>
					<Link href="/login">
						<Typography variant="h5" className={classes.title}>
							AllergI
						</Typography>
						{/* <img src={allergiLogo} className={classes.logos} /> */}
					</Link>
					{props.children}
					<Link href="https://mayoclinic.org" className={classes.mayoLogo}>
						<img src={mayoLogo} className={classes.logos} alt='Visit Mayo Clinic' />
					</Link>
				</Card>
				<BottomBar/>
			</Container>
		</>
	);
}